import { useResponsive, Icon } from '@aptuno/aptuno-ui';
import { environment } from '@shared/environment';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, EffectCoverflow, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import {
  SectionPlans,
  LabelSection,
  PlansContainer,
  PlanBox,
  PlanTitle,
  PlanItemStyle,
  PlanItemText,
  ReferencePlan,
  Tag,
} from './PublicationPlans.styled';

const PlanItem = (props) => {
  return (
    <PlanItemStyle iconColor={props.iconColor} backgroundColor={props.backgroundColor}>
      <Icon width="14px" icon={props.icon} aria-label={props.icon} />
      <PlanItemText>{props.children}</PlanItemText>
    </PlanItemStyle>
  );
};

const defaultIconColor = '#CDCDCD';
const getItemsView = (items) =>
  items.map((item, idx) => {
    return (
      <PlanItem
        key={idx}
        icon={item.icon}
        backgroundColor={item.backgroundColor}
        iconColor={item.iconColor || defaultIconColor}
      >
        <span dangerouslySetInnerHTML={{ __html: item.text }}></span>
        {item.referencePlanText && (
          <ReferencePlan color={item.referencePlanColor}>{item.referencePlanText}</ReferencePlan>
        )}
      </PlanItem>
    );
  });

const PublicationPlans = () => {
  const { isMobile, isDesktop, isMediumSize } = useResponsive();
  const { aptunoBrokerage, aptunoWarranty, aptunoPlus, blueAptuno } = environment.plans;

  return (
    <SectionPlans isDesktop={isDesktop} className="section_content">
      <LabelSection id="nuestros-planes" isDesktop={isDesktop} isMediumSize={isMediumSize}>
        Nuestros planes y todos los beneficios que mereces:
      </LabelSection>
      <PlansContainer>
        <Swiper
          effect={isMobile ? 'coverflow' : 'fade'}
          grabCursor={true}
          centeredSlides={isMobile ? true : undefined}
          slidesPerView={'auto'}
          coverflowEffect={{
            rotate: 50,
            stretch: 10,
            depth: 100,
            modifier: 1,
            slideShadows: false,
          }}
          pagination={true}
          modules={[EffectCoverflow, Pagination, Autoplay]}
          className="mySwiper"
          loop={isMobile ? true : false}
          autoplay={{
            delay: 5000,
            disableOnInteraction: true,
          }}
        >
          <SwiperSlide key={0}>
            <PlanBox color="#FFDE87">
              <PlanTitle color="#F0AE00">{aptunoBrokerage.friendlyName}</PlanTitle>
              <Tag color="#F0AE00">Incluye</Tag>
              {getItemsView(aptunoBrokerage.includes)}
              <Tag color="#F0AE00">Tú pagas</Tag>
              {getItemsView(aptunoBrokerage.price)}
            </PlanBox>
          </SwiperSlide>

          <SwiperSlide key={1}>
            <PlanBox color="#D250E6">
              <PlanTitle color="#D250E6">{aptunoWarranty.friendlyName}</PlanTitle>
              <Tag color="#D250E6">Incluye</Tag>
              {getItemsView(aptunoWarranty.includes)}
              <Tag color="#D250E6">Tú pagas</Tag>
              {getItemsView(aptunoWarranty.price)}
            </PlanBox>
          </SwiperSlide>

          <SwiperSlide key={2}>
            <PlanBox color="#6F9AFF">
              <PlanTitle color="#0055FB">{blueAptuno.friendlyName}</PlanTitle>
              <Tag>Incluye</Tag>
              {getItemsView(blueAptuno.includes)}
              <Tag>Tú pagas</Tag>
              {getItemsView(blueAptuno.price)}
            </PlanBox>
          </SwiperSlide>

          <SwiperSlide key={3}>
            <PlanBox color="#8AE4AE">
              <PlanTitle color="#21AF5A">{aptunoPlus.friendlyName}</PlanTitle>
              <Tag color="#21AF5A">Incluye</Tag>
              {getItemsView(aptunoPlus.includes)}
              <Tag color="#21AF5A">Tú pagas</Tag>
              {getItemsView(aptunoPlus.price)}
            </PlanBox>
          </SwiperSlide>
        </Swiper>
      </PlansContainer>
    </SectionPlans>
  );
};

export default PublicationPlans;
